'use strict';

/* jshint -W098 */
angular.module('mean.system-bids').controller('ModalEditTradeController', ['$scope', 'Global', '$uibModalInstance', 'trade', 'selectedBid', 'toaster',
  function($scope, Global, $uibModalInstance, trade, selectedBid, toaster) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-bids'
    };

    console.log('ModalEditTradeController');

    $scope.dateOptions = {
        formatYear: 'yy',
        maxDate: new Date(2030, 1, 20),
        showWeeks: false,
        startingDay: 0
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened = true;
    };

    $scope.editOpen = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.editOpened = true;
    };

    $scope.open1 = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened1 = true;
    };

    $scope.open2 = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened2 = true;
    };

    $scope.open3 = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened3 = true;
    };

    $scope.open4 = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened4 = true;
    };

    $scope.trade = trade;
    $scope.selectedBid = selectedBid;

    $scope.updateDates = function(item) {
        if(item.date_received)
            item.date_received = new Date(item.date_received);
        if(item.date_requested)
            item.date_requested = new Date(item.date_requested);
        if(item.date_declined)
            item.date_declined = new Date(item.date_declined);
        if(item.date_rejected)
            item.date_rejected = new Date(item.date_rejected);
        if(item.date_accepted)
            item.date_accepted = new Date(item.date_accepted);
        if(item.date_completed)
            item.date_completed = new Date(item.date_completed);
    };

    $scope.removeDates = function(item) {
        if(!item.date_received || item.date_received == 'Invalid Date')
            delete item.date_received;
        if(!item.date_requested || item.date_requested == 'Invalid Date')
            delete item.date_requested;
        if(!item.date_declined || item.date_declined == 'Invalid Date')
            delete item.date_declined;
        if(!item.date_rejected || item.date_rejected == 'Invalid Date')
            delete item.date_rejected;
        if(!item.date_accepted || item.date_accepted == 'Invalid Date')
            delete item.date_accepted;
        if(!item.date_completed || item.date_completed == 'Invalid Date')
            delete item.date_completed;
    };

    $scope.ok = function () {
        $uibModalInstance.close($scope.selected.item);
    };

    $scope.acceptTradeEdits = function() {
        var idx = $scope.selectedBid.bidding_trades.indexOf($scope.trade);
        $scope.removeDates($scope.trade);
        $scope.trade.$update(function(success) {
            $scope.updateDates(success);
            $scope.selectedBid.bidding_trades[idx] = success;
            $uibModalInstance.close();
            toaster.pop('success', 'Trade Updated');
        }, function(error) {
            //$scope.selectedBid.bidding_trades[idx] = $scope.backuptrade;
            toaster.pop('error', 'Trade DB Error', error);
        });
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-bids/public/controllers/modal-edit-trade-controller.js